<template lang="pug">
  .component-accordion.accordion(data-accordion="",  :data-allow-all-closed="true")
    slot
</template>
<script type="text/babel">
  export default {
    name: "Accordion",
    mounted() {
      this.accordion = new Foundation.Accordion($(this.$el))
    },
    updated() {
      if (this.accordion) {
        this.accordion.destroy()
        this.accordion = new Foundation.Accordion($(this.$el))
      }
    },
    destroyed() {
      this.accordion.destroy()
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Accordion.vue?35e594b9